<template>
  <panel-card
      :badge="objectsBadge"
      title="Mixed selection"
      icon="layers"
      class="mixed-selection-panel"
      highlight>
    <field-group
        label="Align selection"
        compact>
      <position-controls
          :horizontal="shownAlignment.horizontal"
          :vertical="shownAlignment.vertical"
          @align="onPositionAlign"/>
    </field-group>
    <slot/>
  </panel-card>
</template>

<script>
import panelContext from '@/components/LeftSection/mixins/panelContext';
import objectAlignment from '@/components/LeftSection/mixins/objectAlignment';
import PanelCard from '@/components/LeftSection/ui/PanelCard';
import FieldGroup from '@/components/LeftSection/ui/FieldGroup';
import PositionControls from '@/components/LeftSection/ui/PositionControls';

export default {
  name:       'MixedSelectionPanel',
  components: {
    'panel-card':        PanelCard,
    'field-group':       FieldGroup,
    'position-controls': PositionControls,
  },
  mixins: [panelContext, objectAlignment],
  props:  {
    width:       { type: Number, default: 0 },
    height:      { type: Number, default: 0 },
    productCrop: { type: Object, default: null },
  },
  computed: {
    objectsBadge() {
      const count = this.getSelectedObjectsList.length;
      return `${count} object${count === 1 ? '' : 's'}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.mixed-selection-panel {
  margin-top: 12px;
}
</style>
